export const hi = {
  meta: {
    home: {
      title: "KAZIM'S | प्रीमियम पत्ती चाय",
      desc: "KAZIM'S प्रीमियम पत्ती चाय खोजिए — सिलीगुड़ी, न्यू जलपाईगुड़ी, दार्जीलिंग और गुवाहाटी के प्रसिद्ध चाय क्षेत्रों से सोर्स की गई।",
    },
    about: {
      title: "KAZIM'S के बारे में | प्रीमियम पत्ती चाय",
      desc: "1 सितंबर 2026 को स्थापित, KAZIM'S आप तक लाता है प्रीमियम पत्ती चाय — सीधी पहाड़ों से।",
    },
    ourTea: {
      title: "हमारी चाय | KAZIM'S प्रीमियम पत्ती चाय",
      desc: "काज़िम्स फ्लेवर फ्यूज़न टी देखिए — सिलीगुड़ी, न्यू जलपाईगुड़ी, दार्जीलिंग और गुवाहाटी से सोर्स की गई प्रीमियम पत्ती चाय। COD पर ऑर्डर करें।",
    },
    product: {
      title: "काज़िम्स फ्लेवर फ्यूज़न टी | KAZIM'S",
      desc: "काज़िम्स फ्लेवर फ्यूज़न टी — प्रीमियम पत्ती चाय, 1 KG पैक, ₹360, भारत के प्रसिद्ध चाय क्षेत्रों से। COD पर ऑर्डर करें।",
    },
    contact: {
      title: "संपर्क करें | KAZIM'S प्रीमियम पत्ती चाय",
      desc: "प्रीमियम पत्ती चाय की पूछताछ के लिए KAZIM'S को कॉल, व्हाट्सऐप या ईमेल करें। इमामगंज, मऊ, उत्तर प्रदेश।",
    },
    faq: {
      title: "सामान्य सवाल | KAZIM'S प्रीमियम पत्ती चाय",
      desc: "KAZIM'S और हमारी चाय के बारे में अक्सर पूछे जाने वाले सवाल — सोर्सिंग, पैक साइज़, ऑर्डरिंग, COD और संपर्क।",
    },
    privacy: { title: "गोपनीयता नीति | KAZIM'S", desc: "KAZIM'S आपकी जानकारी को कैसे इस्तेमाल करता है।" },
    terms: { title: "नियम और शर्तें | KAZIM'S", desc: "KAZIM'S वेबसाइट के लिए नियम और शर्तें।" },
    shipping: { title: "शिपिंग की जानकारी | KAZIM'S", desc: "KAZIM'S प्रीमियम पत्ती चाय की शिपिंग, डिस्पैच और ट्रैकिंग जानकारी।" },
    refund: { title: "रिटर्न / रिफंड की जानकारी | KAZIM'S", desc: "KAZIM'S प्रीमियम पत्ती चाय की रिटर्न और रिफंड जानकारी।" },
  },
  nav: {
    home: "होम",
    about: "हमारे बारे में",
    ourTea: "हमारी चाय",
    contact: "संपर्क",
    explore: "चाय देखें",
    menuOpen: "मेनू खोलें",
    menuClose: "मेनू बंद करें",
  },
  hero: {
    eyebrow: "एक प्रीमियम भारतीय चाय ब्रांड",
    line1: "प्रीमियम पत्ती चाय,",
    line2: "पहाड़ों से, बिल्कुल शुद्ध।",
    sub: "भारत के प्रसिद्ध चाय क्षेत्रों से चुनी गई शुद्ध, सुगंधित और बारीकी से छाँटी गई चाय की पत्तियाँ।",
    ctaPrimary: "हमारी चाय देखें",
    ctaSecondary: "KAZIM'S को जानें",
    est: "स्थापना — 1 सितंबर 2026",
    place: "मऊ · उत्तर प्रदेश · भारत",
    scroll: "स्क्रॉल करें",
  },
  marquee: { label: "हमारे चाय क्षेत्र" },
  intro: {
    eyebrow: "ब्रांड की झलक",
    heading: "केवल चाय नहीं। एक अनुभव।",
    body: "1 सितंबर 2026 को स्थापित काज़िम्स सिलीगुड़ी, न्यू जलपाईगुड़ी, दार्जीलिंग और गुवाहाटी से प्रीमियम पत्ती चाय लाता है। हमारा उद्देश्य सरल है — शुद्ध, सुगंधित और असाधारण चाय, जो हर कप को ख़ास बना दे।",
    cta: "KAZIM'S को जानें",
    badge: "स्थापना 2026",
    imgAlt: "हाथ से सावधानी से तोड़ी जाती ताज़ी चाय की पत्तियाँ",
  },
  origins: {
    eyebrow: "चाय के इलाके",
    heading: "चार प्रसिद्ध क्षेत्रों से",
    body: "काज़िम्स का हर कप उत्तरी बंगाल और असम के चाय इलाकों से शुरू होता है। हर क्षेत्र हमारे मिश्रण में अपना अलग रंग भरता है।",
  },
  signature: {
    eyebrow: "सिग्नेचर मिश्रण",
    heading: "हमारी सिग्नेचर चाय",
    highlightsTitle: "ख़ास क्यों",
    priceLabel: "कीमत",
    sizeLabel: "पैक साइज़",
    viewDetails: "पूरी जानकारी देखें",
    buyNow: "अभी खरीदें",
    imgAlt: "काज़िम्स फ्लेवर फ्यूज़न टी — सुनहरे किनार वाले गहरे कप में",
  },
  quality: {
    eyebrow: "काज़िम्स का मानक",
    heading: "हर पत्ती में, हर कप में",
    items: [
      { t: "प्रीमियम पत्ती चाय", d: "साबुत, बेहतरीन छँटाई की पत्तियाँ — शुद्धता और स्वाद के लिए चुनी गई।" },
      { t: "सावधानी से चुनी गई", d: "हर लॉट की बारीकी से जाँच होती है, तभी वह काज़िम्स कहलाता है।" },
      { t: "समृद्ध सुगंध", d: "पहली चुस्की से पहले ही खिल उठने वाली गहरी, सुखद सुगंध।" },
      { t: "असाधारण स्वाद", d: "स्मूद, परतों भरा स्वाद — जो ज़ुबान पर हल्का महसूस हो।" },
    ],
  },
  homeCta: {
    eyebrow: "ऑर्डर और पूछताछ",
    heading: "जहाँ चाय केवल पेय नहीं — एक अनुभव है।",
    body: "कैश ऑन डिलीवरी पर ऑनलाइन ऑर्डर करें, या प्रीपेड चुनें — डिस्पैच से पहले हम आपसे पेमेंट पक्का कर लेते हैं। और कुछ? सीधे संपर्क करें।",
    call: "कॉल करें",
    whatsapp: "व्हाट्सऐप करें",
  },
  footer: {
    tagline: "प्रीमियम पत्ती चाय, पहाड़ों सीधे आप तक।",
    quick: "त्वरित लिंक",
    contactTitle: "संपर्क",
    phoneLabel: "फ़ोन",
    emailLabel: "ईमेल",
    addressTitle: "पता",
    follow: "इंस्टाग्राम",
    track: "ऑर्डर ट्रैक करें",
    rights: "© 2026 KAZIM'S. सर्वाधिकार सुरक्षित।",
    privacy: "गोपनीयता नीति",
    terms: "नियम और शर्तें",
    shipping: "शिपिंग की जानकारी",
    refund: "रिटर्न / रिफंड की जानकारी",
  },
  ourTeaPage: {
    eyebrow: "हमारी चाय",
    heading: "काज़िम्स संग्रह",
    body: "भारत के प्रसिद्ध चाय क्षेत्रों से बारीकी से चुनी गई हमारी प्रीमियम पत्ती चाय। संग्रह में जल्द और मिश्रण जुड़ेंगे।",
    noteTitle: "ऑर्डर करना आसान है",
    note: "कैश ऑन डिलीवरी पर ऑनलाइन ऑर्डर करें, या प्रीपेड चुनें — पेमेंट पहले आपसे पक्का करते हैं। थोक पूछताछ: 6306859310 पर कॉल या व्हाट्सऐप करें, या kazims5050@gmail.com पर ईमेल करें।",
    brewTitle: "चाय बनाने का तरीका",
    brew: [
      { t: "पानी उबालें", d: "एक कप ताज़ा पानी उबालकर एक पल ठंडा होने दें।" },
      { t: "पत्तियाँ डालें", d: "प्रति कप एक चम्मच काज़िम्स फ्लेवर फ्यूज़न टी लें।" },
      { t: "ढककर रखें", d: "ढककर 3–4 मिनट पकने दें, ताकि सुगंध पूरी खुले।" },
      { t: "छानकर परोसें", d: "छान लें, दूध-चीनी अपने स्वाद से मिलाएँ और गरम परोसें।" },
    ],
    moreTitle: "और मिश्रण आ रहे हैं",
    moreBody: "इस पेज पर जल्द नए ब्लेंड जोड़े जाएँगे। मौजूदा उपलब्धता के लिए हमसे सीधे संपर्क करें।",
    imgAlt: "लकड़ी की ट्रे पर सुनहरे छलनी में रखी खुली चाय की पत्तियाँ",
  },
  productPage: {
    overview: "परिचय",
    highlights: "ख़ासियतें",
    origin: "उद्गम",
    category: "श्रेणी",
    size: "पैक साइज़",
    price: "कीमत",
    availability: "उपलब्ध मात्रा",
    availabilityValue: "स्टॉक में — 1 KG पैक",
    buy: "अभी खरीदें",
    inlineNote: "पूरे भारत में कैश ऑन डिलीवरी उपलब्ध · प्रीपेड ऑर्डर पेमेंट लेकर पक्का किए जाते हैं",
    notice: "ऑनलाइन ऑर्डरिंग अभी उपलब्ध नहीं है। कृपया उत्पाद की उपलब्धता और खरीद की जानकारी के लिए सीधे KAZIM'S से संपर्क करें।",
    call: "कॉल करें",
    whatsapp: "व्हाट्सऐप करें",
    email: "ईमेल करें",
    back: "सभी चाय",
    moreTitle: "काज़िम्स से और भी",
    moreBody: "नए ब्लेंड जल्द इस पेज पर जोड़े जाएँगे। मौजूदा उपलब्धता के लिए हमसे सीधे संपर्क करें।",
  },
  checkout: {
    title: "ऑर्डर करें",
    sub: "पूरे भारत में कैश ऑन डिलीवरी उपलब्ध है। प्रीपेड ऑर्डर हमारी टीम आपसे पेमेंट लेकर आगे बढ़ाती है।",
    name: "पूरा नाम",
    namePh: "आपका पूरा नाम",
    phone: "मोबाइल नंबर",
    phonePh: "10 अंकों का मोबाइल नंबर",
    email: "ईमेल",
    emailOpt: "(वैकल्पिक)",
    emailPh: "आपका ईमेल",
    address: "पता",
    addressPh: "मकान नं., गली, पहचान",
    city: "शहर",
    cityPh: "आपका शहर",
    state: "राज्य",
    statePh: "आपका राज्य",
    pincode: "पिन कोड",
    pincodePh: "6 अंकों का पिन कोड",
    qty: "मात्रा",
    payment: "भुगतान का तरीका",
    cod: "कैश ऑन डिलीवरी",
    codNote: "चाय आपके दरवाज़े पर पहुँचने पर भुगतान करें।",
    prepaid: "प्रीपेड",
    prepaidNote: "डिस्पैच से पहले हम आपसे पेमेंट लेकर ऑर्डर पक्का करेंगे।",
    total: "कुल",
    place: "ऑर्डर करें",
    placing: "ऑर्डर हो रहा है…",
    successT: "ऑर्डर मिल गया",
    successB: "धन्यवाद! आपका ऑर्डर मिल गया है — जल्द ही पुष्टि की जाएगी। डिलीवरी ट्रैक करने के लिए यह ऑर्डर आईडी संभालकर रखें।",
    orderIdLabel: "ऑर्डर आईडी",
    viewOrder: "ऑर्डर और ट्रैकिंग देखें",
    continue: "और देखें",
    error: "कृपया अपनी जानकारी जाँचें — पूरा नाम, 10 अंकों का मोबाइल नंबर, पूरा पता और सही 6 अंकों का पिन कोड ज़रूरी है।",
  },
  orderPage: {
    thanks: "आपके ऑर्डर के लिए धन्यवाद",
    orderLabel: "ऑर्डर आईडी",
    statusLabel: "मौजूदा स्थिति",
    items: "सामान",
    total: "ऑर्डर मूल्य",
    payment: "भुगतान",
    paymentStatus: {
      cod_pending: "डिलीवरी पर भुगतान (COD)",
      payment_pending: "पेमेंट लिया जाना बाकी",
      paid: "भुगतान हो गया",
    },
    deliverTo: "डिलीवरी की जानकारी",
    awb: "AWB",
    courier: "कूरियर",
    noTracking: "शिपमेंट भेजे जाने के बाद ट्रैकिंग यहाँ दिखेगी।",
    activities: "अपडेट",
    trackUrl: "लाइव ट्रैकिंग खोलें",
    notFound: "यह ऑर्डर नहीं मिला। कृपया ऑर्डर आईडी जाँचें।",
    needHelp: "ऑर्डर में मदद चाहिए?",
    call: "कॉल करें",
    whatsapp: "व्हाट्सऐप करें",
    home: "होम पर चलें",
    statuses: {
      New: "नई",
      Processing: "प्रोसेसिंग",
      Shipped: "भेज दी गई",
      "Out for Delivery": "डिलीवरी के लिए निकली",
      Delivered: "डिलीवर हो गई",
      Cancelled: "रद्द",
    },
  },
  track: {
    title: "ऑर्डर ट्रैक करें",
    sub: "कन्फर्मेशन पेज या व्हाट्सऐप मैसेज में मिली ऑर्डर आईडी डालें।",
    placeholder: "जैसे KZ1A2B3C4D",
    button: "ऑर्डर ट्रैक करें",
    notFound: "इस आईडी का कोई ऑर्डर नहीं मिला। कृपया जाँचकर दोबारा कोशिश करें।",
  },
  aboutPage: {
    eyebrow: "हमारे बारे में",
    heading: "KAZIM'S के बारे में",
    lead1: "प्रीमियम पत्ती चाय, पहाड़ों सीधे आप तक।",
    lead2: "1 सितंबर 2026 को स्थापित, काज़िम्स सिलीगुड़ी, न्यू जलपाईगुड़ी, दार्जीलिंग और गुवाहाटी से प्रीमियम पत्ती चाय लाता है।",
    lead3: "हमारा उद्देश्य सरल है — शुद्ध, सुगंधित और असाधारण चाय, जो हर कप को ख़ास बना दे।",
    quote: "Kazims — जहाँ चाय केवल पेय नहीं, एक अनुभव है।",
    story: {
      n: "01",
      t: "हमारी कहानी",
      b: "काज़िम्स की शुरुआत एक साधारण सोच से हुई — पहाड़ों की बेहतरीन पत्ती चाय को मऊ के घरों तक पहुँचाना। 1 सितंबर 2026 को शुरू हुआ यह सफ़र आज भी उसी वादे के साथ चल रहा है: शुद्ध, सुगंधित, ईमानदार चाय।",
    },
    philosophy: {
      n: "02",
      t: "हमारा दर्शन",
      b: "हम चाय को केवल पेय नहीं, एक अनुभव मानते हैं। हमारा तरीका है — कम चीज़ें, पर बेहतर: अच्छी पत्ती, सधा हुआ मिश्रण और एक कप जो याद रह जाए। कोई शॉर्टकट नहीं, बस ठीक से बनी चाय।",
    },
    qualityF: {
      n: "03",
      t: "क्वालिटी पर फ़ोकस",
      b: "हर लॉट की पैकिंग से पहले जाँच होती है — पत्ती, सुगंध और स्वाद। जो हमारे मानक पर खरा नहीं उतरता, वह काज़िम्स नहीं कहलाता। क्वालिटी ही हमारा असली विज्ञापन है।",
    },
    sourcing: {
      n: "04",
      t: "चाय कहाँ से आती है",
      b: "हमारी चाय सिलीगुड़ी, न्यू जलपाईगुड़ी, दार्जीलिंग और गुवाहाटी से आती है — बेहतरीन चाय के लिए मशहूर इलाके। हर क्षेत्र की अपनी ताकत, अपनी सुगंध है — और सब एक संतुलित मिश्रण में मिलती है।",
    },
    imgAlt: "हरे चाय बाग़ान में ताज़ी चाय की पत्तियाँ तोड़ते हाथ",
  },
  contactPage: {
    eyebrow: "संपर्क",
    heading: "आइए, चाय पर बात करें",
    body: "KAZIM'S से सीधे जुड़ें — कॉल, व्हाट्सऐप, ईमेल या इंस्टाग्राम, जो आपको सही लगे। उपलब्धता और खरीद के लिए हम हाज़िर हैं।",
    infoTitle: "सीधा संपर्क",
    callLabel: "कॉल करें",
    waLabel: "व्हाट्सऐप करें",
    emailLabel: "ईमेल करें",
    instaLabel: "इंस्टाग्राम",
    addressTitle: "हमारा पता",
    mapTitle: "हमसे मिलिए",
    formTitle: "पूछताछ भेजें",
    formBody: "फ़ॉर्म भरें, हम जल्द आपसे संपर्क करेंगे। चाहें तो अपनी पूछताछ सीधे हमारे व्हाट्सऐप पर भी भेज सकते हैं।",
    name: "नाम",
    namePh: "आपका पूरा नाम",
    mobile: "मोबाइल नंबर",
    mobilePh: "10 अंकों का मोबाइल नंबर",
    email: "ईमेल",
    emailPh: "आपका ईमेल",
    emailOpt: "(वैकल्पिक)",
    message: "संदेश",
    messagePh: "आप क्या जानना चाहते हैं?",
    send: "पूछताछ भेजें",
    sending: "भेजा जा रहा है…",
    viaWa: "इसके बजाय व्हाट्सऐप पर भेजें",
    successT: "पूछताछ मिल गई",
    successB: "धन्यवाद! आपकी पूछताछ हम तक पहुँच गई है — हम जल्द ही आपसे संपर्क करेंगे। जल्दी जवाब चाहिए? व्हाट्सऐप पर भी भेजें।",
    errorB: "आपकी पूछताछ भेजी नहीं जा सकी। कृपया दोबारा कोशिश करें, या सीधे व्हाट्सऐप/कॉल करें।",
    formError: "कृपया अपनी जानकारी जाँचें — नाम, सही मोबाइल नंबर और संदेश ज़रूरी हैं।",
  },
  faqPage: {
    eyebrow: "सामान्य सवाल",
    heading: "अक्सर पूछे जाने वाले सवाल",
    body: "KAZIM'S और हमारी चाय के बारे में वह सब, जो आप जानना चाहेंगे।",
    items: [
      {
        q: "KAZIM'S क्या है?",
        a: "KAZIM'S एक प्रीमियम पत्ती चाय ब्रांड है, जिसकी शुरुआत 1 सितंबर 2026 को हुई। यह इमामगंज, मऊ, उत्तर प्रदेश से संचालित होता है और भारत के प्रसिद्ध चाय क्षेत्रों से बारीकी से चुनी गई चाय पेश करता है।",
      },
      {
        q: "KAZIM'S की चाय कहाँ से आती है?",
        a: "हमारी चाय सिलीगुड़ी, न्यू जलपाईगुड़ी, दार्जीलिंग और गुवाहाटी से सोर्स की जाती है — बेहतरीन चाय के लिए मशहूर इलाके।",
      },
      {
        q: "फ्लेवर फ्यूज़न टी क्या है?",
        a: "काज़िम्स फ्लेवर फ्यूज़न टी हमारी सिग्नेचर प्रीमियम पत्ती चाय है — सिलीगुड़ी, न्यू जलपाईगुड़ी, दार्जीलिंग और गुवाहाटी की चायों का बारीकी से तैयार किया मिश्रण। हर पत्ती शुद्धता, सुगंध और अपनेपन के लिए चुनी जाती है, जिससे कप स्मूद और परतों भरा बनता है — स्वाद में गहरा, पर फिर भी हल्का।",
      },
      {
        q: "अभी कौन-सा पैक साइज़ उपलब्ध है?",
        a: "काज़िम्स फ्लेवर फ्यूज़न टी अभी 1 KG पैक में उपलब्ध है, कीमत ₹360।",
      },
      {
        q: "KAZIM'S की चाय कैसे खरीदें?",
        a: "सीधे इस वेबसाइट पर ऑर्डर करें — काज़िम्स फ्लेवर फ्यूज़न टी खोलकर 'अभी खरीदें' दबाएँ, फिर कैश ऑन डिलीवरी या प्रीपेड चुनें। थोक की पूछताछ के लिए 6306859310 पर कॉल या व्हाट्सऐप करें।",
      },
      {
        q: "क्या COD की सुविधा है?",
        a: "हाँ — ऑनलाइन ऑर्डर के लिए पूरे भारत में कैश ऑन डिलीवरी उपलब्ध है, जो हमारे कूरियर पार्टनर्स से डिलीवर होती है।",
      },
      {
        q: "क्या ऑनलाइन पेमेंट की सुविधा है?",
        a: "ऑनलाइन पेमेंट अभी उपलब्ध नहीं है। प्रीपेड ऑर्डर हमारी टीम आपसे सीधे पेमेंट (जैसे UPI) लेकर पक्का करती है।",
      },
      {
        q: "KAZIM'S से संपर्क कैसे करें?",
        a: "6306859310 पर कॉल या व्हाट्सऐप करें, kazims5050@gmail.com पर ईमेल करें, इंस्टाग्राम पर @KAZIMS50 फ़ॉलो करें, या भटकुआ पट्टी, दया राय, बीटीआई मस्जिद के पास, इमामगंज, मऊ, उत्तर प्रदेश - 275101 पर मिलें।",
      },
    ],
  },
  legal: {
    privacy: {
      title: "गोपनीयता नीति",
      intro: "KAZIM'S आपकी गोपनीयता का सम्मान करता है। यह नीति बताती है कि इस वेबसाइट के ज़रिए हमें क्या जानकारी मिलती है और उसका उपयोग कैसे होता है।",
      sections: [
        { h: "हम क्या जानकारी लेते हैं", p: ["जब आप ऑर्डर करते हैं या पूछताछ भेजते हैं, तो हमें आपकी दी हुई जानकारी मिलती है: नाम, मोबाइल नंबर, ईमेल (अगर साझा किया हो), डिलीवरी का पता और ऑर्डर की जानकारी। हम कोई ऑनलाइन पेमेंट जानकारी नहीं लेते, क्योंकि ऑनलाइन पेमेंट अभी उपलब्ध नहीं है।"] },
        { h: "जानकारी का उपयोग कैसे होता है", p: ["आपकी जानकारी केवल ऑर्डर पूरा करने, हमारे कूरियर पार्टनर्स के ज़रिए डिलीवरी और आपके सवालों के जवाब के लिए इस्तेमाल होती है। हम आपकी जानकारी किसी को नहीं बेचते या किराए पर नहीं देते।"] },
        { h: "तीसरे पक्ष की सेवाएँ", p: ["ऑर्डर Shiprocket से जुड़े कूरियर पार्टनर्स के ज़रिए भेजे जाते हैं, जिन्हें डिलीवरी के लिए ज़रूरी जानकारी दी जाती है। इस वेबसाइट पर गूगल मैप्स एम्बेड है और व्हाट्सऐप, इंस्टाग्राम तथा फ़ोन डायलर के लिंक हैं; इनके इस्तेमाल पर उनकी अपनी गोपनीयता नीतियाँ लागू होती हैं।"] },
        { h: "जानकारी कितनी देर रखते हैं", p: ["ऑर्डर और पूछताछ की जानकारी उतने समय तक रखी जाती है, जितना आपकी सेवा और साधारण रिकॉर्ड के लिए ज़रूरी है। आप कभी भी संपर्क करके अपनी जानकारी हटाने का अनुरोध कर सकते हैं।"] },
        { h: "संपर्क", p: ["किसी भी गोपनीयता सवाल या अनुरोध के लिए हमसे 6306859310 पर संपर्क करें या kazims5050@gmail.com पर ईमेल करें।"] },
      ],
    },
    terms: {
      title: "नियम और शर्तें",
      intro: "KAZIM'S वेबसाइट में आपका स्वागत है। इस साइट का उपयोग करके आप नीचे दी शर्तों से सहमत होते हैं।",
      sections: [
        { h: "KAZIM'S के बारे में", p: ["KAZIM'S एक पार्टनरशिप व्यवसाय है, जिसका पता है: भटकुआ पट्टी, दया राय, बीटीआई मस्जिद के पास, इमामगंज, मऊ, उत्तर प्रदेश - 275101, भारत। इसकी शुरुआत 1 सितंबर 2026 को हुई।"] },
        { h: "उत्पाद की जानकारी", p: ["उत्पाद के नाम, विवरण, पैक साइज़ और कीमत सूचना के लिए दी गई हैं। अभी काज़िम्स फ्लेवर फ्यूज़न टी 1 KG पैक में ₹360 पर उपलब्ध है। चाय एक प्राकृतिक उत्पाद है, इसलिए हर लॉट में थोड़ा स्वाभाविक अंतर सामान्य है।"] },
        { h: "ऑर्डरिंग और भुगतान", p: ["इस वेबसाइट पर कैश ऑन डिलीवरी या प्रीपेड ऑर्डर किया जा सकता है — प्रीपेड ऑर्डर में हमारी टीम डिस्पैच से पहले आपसे सीधे पेमेंट (जैसे UPI) लेती है। वेबसाइट पर ऑनलाइन पेमेंट अभी उपलब्ध नहीं है। ऑर्डर हमारी पुष्टि के बाद पक्का माना जाएगा; जिन ऑर्डर की पुष्टि न हो, उन्हें हम रद्द कर सकते हैं।"] },
        { h: "कीमत", p: ["कीमतें भारतीय रुपये में हैं और बिना सूचना बदल सकती हैं। आपकी खरीद पर वही कीमत लागू होगी जो ऑर्डर करते समय दिखाई गई हो।"] },
        { h: "वेबसाइट सामग्री", p: ["इस वेबसाइट की सारी सामग्री — टेक्स्ट, तस्वीरें और डिज़ाइन — KAZIM'S की है। अनुमति के बिना इसे कॉपी या दोबारा इस्तेमाल न करें।"] },
        { h: "संपर्क", p: ["इन शर्तों को लेकर किसी भी सवाल के लिए हमसे 6306859310 पर संपर्क करें या kazims5050@gmail.com पर ईमेल करें।"] },
      ],
    },
    shipping: {
      title: "शिपिंग की जानकारी",
      intro: "KAZIM'S की चाय की डिलीवरी इस तरह काम करती है।",
      sections: [
        { h: "ऑर्डर कैसे करें", p: ["ऑर्डर सीधे इस वेबसाइट पर होते हैं — चेकआउट पर कैश ऑन डिलीवरी या प्रीपेड चुनें। प्रीपेड ऑर्डर पेमेंट आपसे लेकर पक्का किए जाते हैं।"] },
        { h: "डिस्पैच और डिलीवरी", p: ["ऑर्डर पक्का होने के बाद चाय को सावधानी से पैक करके हमारे कूरियर पार्टनर्स को सौंपा जाता है। डिलीवरी का समय जगह के हिसाब से अलग-अलग होता है और आपकी ट्रैकिंग जानकारी के साथ साझा किया जाता है।"] },
        { h: "ऑर्डर ट्रैकिंग", p: ["हर पक्के ऑर्डर को एक ऑर्डर आईडी मिलती है। भेजे जाने के बाद AWB नंबर, कूरियर और लाइव ट्रैकिंग अपडेट आपके ऑर्डर पेज पर दिखते हैं — 'ऑर्डर ट्रैक करें' पेज से भी आप कभी भी देख सकते हैं।"] },
        { h: "सवाल", p: ["अपने इलाके में डिलीवरी को लेकर किसी भी जिज्ञासा के लिए 6306859310 पर संपर्क करें या kazims5050@gmail.com पर ईमेल करें।"] },
      ],
    },
    refund: {
      title: "रिटर्न / रिफंड की जानकारी",
      intro: "हम चाहते हैं कि काज़िम्स का हर कप बेहतरीन हो। रिटर्न और रिफंड इस तरह चलते हैं।",
      sections: [
        { h: "अगर कुछ ग़लत हो", p: ["अगर आपकी चाय ख़राब हालत में पहुँची हो या आपको ऑर्डर किया उत्पाद न मिला हो, तो डिलीवरी के बाद जितनी जल्दी हो सके हमसे संपर्क करें — 6306859310 पर कॉल या व्हाट्सऐप करें, या kazims5050@gmail.com पर ईमेल करें, और अपनी ऑर्डर आईडी व यथासंभव तस्वीरें साझा करें।"] },
        { h: "हम सुधार कैसे करते हैं", p: ["समस्या समझने के बाद हम आपके साथ मिलकर उपयुक्त समाधान निकालेंगे — हालत के हिसाब से बदली (रिप्लेसमेंट) या रिफंड। COD ऑर्डर पर खराब पैकेट दरवाज़े पर लेने से मना कर सकते हैं; प्रीपेड रकम पक्की समस्या की स्थिति में लौटा दी जाती है।"] },
        { h: "स्वाभाविक अंतर", p: ["प्राकृतिक चाय में अलग-अलग लॉट के बीच रंग और सुगंध में थोड़ा अंतर हो सकता है — यह सामान्य है, दोष नहीं।"] },
        { h: "संपर्क", p: ["रिटर्न या रिफंड से जुड़े किसी भी सवाल के लिए हमसे 6306859310 पर संपर्क करें या kazims5050@gmail.com पर ईमेल करें।"] },
      ],
    },
  },
  notFound: {
    title: "पेज नहीं मिला",
    body: "आप जो पेज खोज रहे हैं, वह मौजूद नहीं है या कहीं और चला गया है।",
    home: "होम पर वापस चलें",
  },
};
